import { jsx as _jsx } from "react/jsx-runtime";
import { useForm } from '@awaze/design-system.components.form';
import formatISO from 'date-fns/formatISO';
import React, { useContext, useEffect } from 'react';
export const defaultSearchContext = {};
export const SearchContext = React.createContext({});
export const useSearchFormContext = () => useContext(SearchContext);
const today = new Date();
const tomorrow = new Date(today);
tomorrow.setDate(tomorrow.getDate() + 1);
export const SearchContextProvider = ({ initialValues, defaultConfig, translations, locale = 'en', onSubmit, children, useLegacyDestinationSelector = true, legacyListWithPlaces = {
    enabled: false,
    data: null,
}, autoSuggestSearch, onAutocompleteSelected, onNearbyPropertiesClick, }) => {
    // default value for datepicker input has to be set as ISO string eg '2022-12-25'
    const formattedStartDate = initialValues.start &&
        formatISO(initialValues.start, {
            representation: 'date',
        });
    const configDefaultValues = {
        destination: defaultConfig.destination.defaultValue,
        destinationURL: defaultConfig.destinationURL.defaultValue,
        destinationId: defaultConfig.destinationId.defaultValue,
        adult: defaultConfig.adults.defaultValue,
        child: defaultConfig.children.defaultValue,
        infant: defaultConfig.infants.defaultValue,
        pets: defaultConfig.pets.defaultValue,
        start: defaultConfig.dates.defaultValue,
        range: defaultConfig.flexibility.defaultValue,
        nights: defaultConfig.duration.defaultValue,
        ...(defaultConfig.accommodationType?.defaultValue && {
            accommodationType: defaultConfig.accommodationType.defaultValue,
        }),
    };
    const formattedInitialValues = {
        ...configDefaultValues,
        ...initialValues,
        ...(formattedStartDate && {
            start: formattedStartDate,
        }),
    };
    const formHooks = useForm({
        defaultValues: formattedInitialValues,
    });
    const resetToInitialValues = () => {
        formHooks.reset(formattedInitialValues);
    };
    const resetToConfigDefaults = () => {
        formHooks.reset(configDefaultValues);
    };
    const searchContext = {
        ...defaultSearchContext,
        initialValues,
        defaultConfig,
        translations,
        locale,
        formHooks,
        onSubmit,
        resetToInitialValues,
        resetToConfigDefaults,
        useLegacyDestinationSelector,
        legacyListWithPlaces,
        autoSuggestSearch,
        onAutocompleteSelected,
        onNearbyPropertiesClick,
    };
    const initialValuesStringified = JSON.stringify(initialValues);
    useEffect(() => {
        resetToInitialValues();
    }, [initialValuesStringified]);
    return (_jsx(SearchContext.Provider, { value: searchContext, children: children }));
};
//# sourceMappingURL=search-form.context.js.map